import { createContext } from "react"

interface BonusQuestionSectionContextProps {
  coins: number
  setCoins: (coins: BonusQuestionSectionContextProps["coins"]) => void
  answerState: "success" | "failure" | ""
  setAnswerState: (answerState: BonusQuestionSectionContextProps["answerState"]) => void
}

const BonusQuestionSectionContext = createContext<BonusQuestionSectionContextProps>({
  coins: 0,
  setCoins: () => {},
  answerState: "",
  setAnswerState: () => {},
})

export default BonusQuestionSectionContext
